import { apiFetch } from './api';
import { Execution, CreateExecutionRequest } from '../types/executions';

const API_URL = '/api/executions';

export const executionService = {
  // Get all executions
  async getAll(): Promise<Execution[]> {
    const response = await apiFetch(API_URL);
    if (!response.ok) {
      throw new Error('Failed to fetch executions');
    }
    return response.json();
  },

  // Get specific execution
  async getById(executionId: string): Promise<Execution> {
    const response = await apiFetch(`${API_URL}/${executionId}`);
    if (!response.ok) {
      throw new Error('Failed to fetch execution');
    }
    return response.json();
  },

  // Create new execution
  async create(executionData: CreateExecutionRequest): Promise<Execution> {
    const response = await apiFetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(executionData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create execution');
    }

    return response.json();
  },

  // Update execution (start, cancel, etc.)
  async update(executionId: string, action: string, data?: any): Promise<Execution> {
    const response = await apiFetch(`${API_URL}/${executionId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ action, ...data }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to update execution');
    }

    return response.json();
  },
};
